// Shipping-line titles the Packing Portal may fulfil with its default UPS
// Ground (1 lb) label. Anything else the customer paid for — Priority Mail,
// UPS 2nd Day Air, Next Day Air Saver, 3 Day Select, DHL… — must be shipped
// from Shopify admin with the service they bought; the portal prints a
// "SHIP VIA SHOPIFY" packing slip instead (Eric, 2026-09-11).
//
// Matching is on the NORMALIZED title: lower-case, "®"/"™" stripped, runs of
// whitespace collapsed — so "UPS® Ground" and "UPS Ground" are the same entry.
// Surveyed against 45 days of orders across all stores before writing:
// Amazon Standard / Business Order and Redo Exchange Shipping are ground in
// practice and were added; "Amazon Expedited" deliberately is not.
const RAW = [
    'Team Portal Flat Rate Shipping',
    'Team Portal Flat Rate Shipping II',
    'Team Portal Flat Rate Shipping III',
    'Team Portal Ground Shipping',
    'Team Portal Shipping',
    'UPS® Ground',
    'Free Shipping (Ground)',
    'Ground',
    'Ground Advantage',
    'Ground Shipping',
    'Amazon Standard',
    'Amazon Standard Business Order',
    'Redo Exchange Shipping',
];

export function normalizeShippingTitle(title) {
    return String(title || '')
        .replace(/[®™]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}

export const GROUND_SHIPPING_TITLES = new Set(RAW.map(normalizeShippingTitle));

// True when the title is on the ground list. An EMPTY title returns true —
// orders with no shipping line (drafts, edits) keep today's behaviour; the
// address/pickup guards in QCActionBar handle the genuinely broken cases.
export function isGroundShippingTitle(title) {
    const n = normalizeShippingTitle(title);
    return n === '' || GROUND_SHIPPING_TITLES.has(n);
}
